import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router';
import { tokenFragmentbol } from '../regisztracio/fragment.ts';
import { regisztracioApi, type MegerositesEredmeny } from '../regisztracio/api.ts';
import { HIBA_SZOVEGEK } from '../regisztracio/urlap.ts';
import { Gomb } from '../ui/elemek.tsx';
import BelepesKeret from './BelepesKeret.tsx';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;

export default function RegisztracioMegerosites() {
  // A tokent egyszer olvassuk ki a fragmentből, utána töröljük az URL-ből (előzmény, megosztás, képernyőkép).
  const [token] = useState(() => tokenFragmentbol(window.location.hash));
  const api = useMemo(() => regisztracioApi(SUPABASE_URL ?? ''), []);
  const [toltes, setToltes] = useState(false);
  const [eredmeny, setEredmeny] = useState<MegerositesEredmeny | null>(null);
  const [hiba, setHiba] = useState<string | null>(null);

  useEffect(() => {
    if (window.location.hash) history.replaceState(history.state, '', window.location.pathname + window.location.search);
  }, []);

  // A tokent csak gombnyomásra váltjuk be, így a levelezők linkellenőrzője nem használja el.
  async function megerosit() {
    if (!token) return;
    setToltes(true);
    setHiba(null);
    const r = await api.megerosites(token);
    setToltes(false);
    if (r.ok) setEredmeny(r.adat.eredmeny);
    else setHiba(r.hiba === 'ervenytelen' ? 'A link hibás. Küldje be újra a regisztrációt.' : HIBA_SZOVEGEK[r.hiba]);
  }

  const ujra = <Link to="/regisztracio" className="text-kiemelt underline">Új regisztráció beküldése</Link>;

  if (eredmeny === 'ok' || eredmeny === 'mar_megerositve') {
    return (
      <BelepesKeret cim="E-mail-cím megerősítve">
        <p role="status" className="rounded-xl border border-kiemelt bg-kiemelt-halvany px-3.5 py-2.5 text-sm">
          Köszönjük, az e-mail-címét megerősítette. A regisztrációját hamarosan elbíráljuk.
        </p>
        <Link to="/belepes" className="text-kiemelt underline">Vissza a belépéshez</Link>
      </BelepesKeret>
    );
  }
  if (eredmeny === 'lejart' || eredmeny === 'nincs' || !token) {
    return (
      <BelepesKeret cim="Hibás link">
        <p role="alert">A link lejárt vagy hibás. Küldje be újra a regisztrációt.</p>
        {ujra}
      </BelepesKeret>
    );
  }
  return (
    <BelepesKeret cim="E-mail-cím megerősítése">
      <p className="text-szoveg-halk">A regisztráció folytatásához erősítse meg a kapcsolattartó e-mail-címét.</p>
      <Gomb toltes={toltes} onClick={() => void megerosit()}>E-mail-cím megerősítése</Gomb>
      {hiba && (
        <div className="grid gap-2">
          <p role="alert" className="rounded-xl border border-hiba bg-hiba-hatter px-3.5 py-2.5 text-sm text-hiba">{hiba}</p>
          {ujra}
        </div>
      )}
    </BelepesKeret>
  );
}
